import { Box, Paper, Typography } from "@mui/material";
import { ReactNode } from "react";
import Logo from "../common/Logo";

interface AuthPageLayoutProps {
  title: string;
  subtitle?: string;
  children: ReactNode;
  /** Max width of the card (responsive). */
  maxWidth?: number;
}

/**
 * Centered card layout for login, register, and other public auth pages.
 * Responsive: full-width on small screens, constrained card on larger.
 */
export default function AuthPageLayout({
  title,
  subtitle,
  children,
  maxWidth = 420,
}: AuthPageLayoutProps) {
  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        p: { xs: 2, sm: 3 },
        bgcolor: "background.default",
      }}
    >
      <Paper
        elevation={0}
        variant="outlined"
        sx={{
          width: "100%",
          maxWidth: maxWidth,
          p: { xs: 3, sm: 4 },
          borderRadius: 3,
          borderColor: "divider",
        }}
      >
        <Box sx={{ mb: 2, display: "flex", justifyContent: "center" }}>
          <Logo variant="default" height={100} ariaLabel="KP Golden Tours" />
        </Box>
        <Typography variant="h5" sx={{ fontWeight: 700 }}>
          {title}
        </Typography>
        {subtitle && (
          <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
            {subtitle}
          </Typography>
        )}
        <Box sx={{ mt: 3 }}>{children}</Box>
      </Paper>
    </Box>
  );
}
